module.exports = __webpack_public_path__ + "img/7-2.f6f60203.png";